/* eslint-disable react-hooks/exhaustive-deps */
import {Remove} from 'components/grid-dx/consult-buttons';
import {useGetToken} from 'components/hooks';
import {Column} from 'devextreme-react/data-grid';
import {
  getRequirement,
  useGetProfiles,
} from 'features/edit-course/requirement/hooks/index';
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import IntegrityRoleGrid from '../../../../components/UserRole';
import {i18n2} from '../../../../features/i18n/i18n';
import {REMOVE_PROFILE, SET_PROFILE, SELECT_ALL_PROFILES} from '../types';
import {useSelector} from 'react-redux';
import {getRequirementWithoutAdditional} from '../hooks/getRequirement';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

const Buttons = ({data}: any) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <Remove row={data} type={REMOVE_PROFILE} />
    </div>
  );
};

const SelectedProfilesGrid = (props: any) => {
  const {selectAll, setSelectAll} = props;
  const isTablet = useIsTablet();
  const dispatch = useDispatch();
  const profiles: any[] = useGetProfiles();
  const token = useGetToken();
  const filters = useSelector((state: any) => state.gridReducer.filters);

  useEffect(() => {
    if (selectAll) {
      getRequirementWithoutAdditional(filters, token).then(({data}: any) => {
        setAllProfiles(data);
      });
      setSelectAll(false);
    }
  }, [selectAll]);

  useEffect(() => {
    const additional = JSON.stringify({Value: props.id});
    getRequirement(additional, token).then(({data}: any) => {
      setProfiles(data);
    });
  }, []);

  const setProfiles = (data: any) => {
    dispatch({type: SET_PROFILE, payload: data});
  };

  const setAllProfiles = (data: any) => {
    dispatch({type: SELECT_ALL_PROFILES, payload: data});
  };

  return (
    <>
      <IntegrityRoleGrid
        dataSource={profiles}
        allowActions={false}
        allowIntegrity={false}
        width="600px"
        height="70vh"
        id={['iD_Profile']}>
        <Column caption={i18n2._('Perfil')} dataField="profile_Name" />
        <Column caption={i18n2._('Sector')} dataField="sector_Name" />
        <Column
          caption={i18n2._('#Perfil')}
          visible={false}
          dataField="iD_Profile"
        />
        <Column
          caption={i18n2._('#Sector')}
          visible={false}
          dataField="iD_Sector"
        />
        <Column
          caption=""
          cellComponent={(e: any) => <Buttons data={e.data.data} />}
          width={getActionColumnWidth(1, isTablet)}
          fixed
          alignment="right"
        />
      </IntegrityRoleGrid>
    </>
  );
};

export default SelectedProfilesGrid;
